export default __webpack_public_path__ + "static/media/p7.10543822.JPG";